module.exports = __webpack_public_path__ + "static/media/062-minus.10ff073a.svg";